import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import classnames from 'classnames';
import { hasKey } from 'dibs-ts-utils/exports/hasKey';
// import LazyImage from 'dibs-react-lazy-image';
// import { SeoLink } from 'dibs-elements/exports/SeoLink';

import { tileHeights } from '../constants';

import {
    imageBackgroundColors,
    type ImageBackgroundColor,
    TILE_SIZES,
    type TileSize,
} from '../constants';

import dibsCss from 'dibs-css';
import styles from '../styles/styles.scss';

import { type ProductImage_item$key } from './__generated__/ProductImage_item.graphql';

const itemFragment = graphql`
    fragment ProductImage_item on Item {
        productPhotos: photos(limit: 1) {
            masterOrZoomPath
            smallPath
            versions {
                webPath
            }
        }
    }
`;

type Props = {
    item: ProductImage_item$key | null | undefined;
    imageBackgroundColor?: ImageBackgroundColor;
    itemsPerRow: number;
    onClick?: () => void;
    size: TileSize;
};

export const ProductImage: FC<Props> = ({ item: itemRef, imageBackgroundColor, size }) => {
    const item = useFragment(itemFragment, itemRef);
    const productPhotos = item?.productPhotos?.[0];
    const masterOrZoomPath = productPhotos?.masterOrZoomPath || '';
    const imageUrl = new URL(masterOrZoomPath);
    //tile height - item details height - gap between image and item details - image padding
    const tileHeight = tileHeights[size];
    imageUrl.searchParams.set('height', tileHeight);
    const src = imageUrl.toString();
    const backgroundColor =
        imageBackgroundColor && hasKey(imageBackgroundColors, imageBackgroundColor)
            ? imageBackgroundColors[imageBackgroundColor]
            : '';

    if (!src) {
        return null;
    }

    return (
        <figure
            className={classnames(
                dibsCss.flex,
                dibsCss.justifyCenter,
                dibsCss.itemsCenter,
                dibsCss.wAuto,
                dibsCss.m0,
                backgroundColor,
                {
                    [styles.minH170px]: size === TILE_SIZES.small,
                    [styles.minH220px]: size === TILE_SIZES.medium,
                    [styles.minH280px]: size === TILE_SIZES.large || size === TILE_SIZES.auto,
                }
            )}
            data-tn="product-image-container"
        >
            <img
                className={classnames(
                    dibsCss.objectContain,
                    dibsCss.wFull,
                    dibsCss.hFull,
                    dibsCss.pXsmall,
                    {
                        [styles.image]: backgroundColor,
                    }
                )}
                src={src}
                alt=""
            />
        </figure>
    );

    // const thumb = (
    //     <figure data-tn="product-image-container">
    //         {typeof index === 'number' && index < itemsPerRow ? (
    //             <img src={src} alt={title} data-tn="product-image" />
    //         ) : (
    //             <>
    //                 <LazyImage
    //                     srcSetAttributes={srcSetAttributes}
    //                     alt={title}
    //                     // offsetVertical={imageLoadVerticalOffset}
    //                     // onImageLoad={() => {}}
    //                     // useLoFiLazyLoader={useLoFiLazyLoader}
    //                     src={src}
    //                     // imageSize={imageSize || fallbackImageSize}
    //                 />
    //                 <noscript>
    //                     <img src={src} alt={title} {...srcSetAttributes} />
    //                 </noscript>
    //             </>
    //         )}
    //     </figure>
    // );

    // let imageEl = (
    //     <SeoLink
    //         dataTn="product-image-link"
    //         linkData={{ path: pdpUrl, isLinkable: false }}
    //         onClick={onClick}
    //     >
    //         {thumb}
    //     </SeoLink>
    // );

    // if (disableLinks) {
    //     imageEl = thumb;
    // }
    // return imageEl;
};
